import React, { useState, useEffect } from 'react';

import styled from 'styled-components';

import HighlightOffIcon from '@mui/icons-material/HighlightOff';



const Modal = ( {closeModal, title, message, errorMessage}) => {

  return (
    <Wrapper>
      <Container>
        <CloseBtn onClick={()=>closeModal(false)}><HighlightOffIcon sx={{ fontSize: 30 }}/></CloseBtn>
        <ModalContent>
          <Title>{title}</Title>
          {/* <Content>
            <input 
              type="text"
              id="album-name"
              name="album-name"
              onChange={handleChange}
              value={albumName}
              placeholder='album name'/>
          </Content> */}
          {message && <Message>{message}</Message>}
          {errorMessage && <ErrorMessage>{errorMessage}</ErrorMessage>}
          <ButtonsWrapper>
            <CancelBtn onClick={()=>closeModal(false)}>ok</CancelBtn>
          </ButtonsWrapper>
        </ModalContent>
      </Container>
    </Wrapper>
  )
}

export default Modal;

const Wrapper = styled.div `

  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, .6);
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Container = styled.div `
  width: 50%;
  /* height: 50vh; */
  border-radius: 5px;
  background-color: rgba(0, 0, 0, .8);
  border: 1px solid orange;
  padding: .5rem 1rem 4rem;

  display: flex;
  flex-direction: column;
  align-items: center;

  @media screen AND (max-width: 950px) {
    width: 75%;
  }
  
  @media screen AND (max-width: 415px) {
    width: 100%;
  }
`;

const CloseBtn = styled.div `
  align-self: flex-end;
`;

const ModalContent = styled.div `
  width: 75%;
  /* border: 1px solid green; */

  display: flex;
  flex-direction: column;
  align-items: center;

  @media screen AND (max-width: 600px) {
    width: 100%;
  }
`;

const Title = styled.div `
  text-transform: capitalize;
  font-size: 1.4rem;
  margin-bottom: 2rem;

  span {
    color: orange;
  }
`;

const Content = styled.div `
  text-align: center;
  margin-top: 2rem;
  text-transform: capitalize;
  font-size: 1.8rem;
  width: 100%; 

  input {
    padding: .2rem .6rem;
    height: 2.6rem;
    font-size: 1.4rem;
    width: 100%; 
  }

`;

const Message = styled.div `
  font-size: 2rem;
  color: green;
  line-height: 2.2rem;
`;

const ErrorMessage = styled.div `
  font-size: 2rem;
  color: red;
  line-height: 2.2rem;
`;


const ButtonsWrapper = styled.div `
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  font-size: 1.2rem;
  margin-top: 3rem;
  width: 100%;
  text-transform: uppercase;
`;

const CancelBtn = styled.div `
  border: 1px solid orange;
  border-radius: 3px;
  padding: .3rem .6rem;
`;
const SaveBtn = styled.div `
  border: 1px solid orange;
  border-radius: 3px;
  padding: .3rem .6rem;
`;